"use client"
import dynamic from 'next/dynamic';
import { useBrowser } from '@/hooks/useBrowser';

const DefaultMobileSide = dynamic(
  () => import('./MobileSide').then((mod) => mod.MobileSide),
  {
    ssr: false,
    loading: () => null,
  },
);

interface MobileDetectProps extends React.PropsWithChildren {
  MobileSideComponent?: React.ComponentType<any>
}
export const MobileDetect = ({
  children,
  MobileSideComponent = DefaultMobileSide,
}: MobileDetectProps) => {
  const browser = useBrowser();

  if (!browser) {
    return children;
  }
  if (browser.parsePlatform().type === 'mobile') {
    return <MobileSideComponent />
  }

  return children;
};
